import { fetch } from '@atlassian/eoc-fetch';

import {
	type GettingStartedPanelData,
	type GettingStartedStepKey,
	type TeamsResponse,
} from '../../common/types';

export interface GetTeamsParams {
	accountId?: string;
	includeTeamExternalDetails?: boolean;
	keyword?: string;
	migratedTeamsOnly?: boolean;
	offset?: number;
	showAvatar?: boolean;
	size?: number;
}

export const getTeams = ({
	url,
	queryParams,
}: {
	queryParams: GetTeamsParams;
	url?: string;
}): Promise<TeamsResponse> => {
	const params = new URLSearchParams();

	if (queryParams.keyword) {
		params.append('keyword', queryParams.keyword);
	}

	if (queryParams.size) {
		params.append('size', queryParams.size.toString());
	}

	if (queryParams.offset) {
		params.append('offset', queryParams.offset.toString());
	}

	if (queryParams.accountId) {
		params.append('memberId', queryParams.accountId);
	}

	if (queryParams.showAvatar) {
		params.append('showAvatar', String(queryParams.showAvatar));
	}

	if (queryParams.includeTeamExternalDetails) {
		params.append('includeTeamExternalDetails', String(queryParams.includeTeamExternalDetails));
	}

	if (queryParams.migratedTeamsOnly) {
		params.append('migratedTeamsOnly', String(queryParams.migratedTeamsOnly));
	}

	if (url) {
		return fetch<TeamsResponse>(`${url}${params.toString() ? `?${params.toString()}` : ''}`, {
			exactUrl: true,
		});
	}

	return fetch<TeamsResponse>(`/v1/teams${params.toString() ? `?${params.toString()}` : ''}`);
};

export const getGettingStartedPanelData = (): Promise<GettingStartedPanelData> => {
	return fetch<GettingStartedPanelData>('/v1/users/getting-started');
};

export const completeGettingStartedStep = (
	stepKey: GettingStartedStepKey,
): Promise<GettingStartedPanelData> => {
	return fetch<GettingStartedPanelData>(`/v1/users/getting-started/${stepKey}/complete`, {
		method: 'PATCH',
	});
};

export const updateAdvancedState = (advanced: boolean): Promise<GettingStartedPanelData> => {
	return fetch<GettingStartedPanelData>(`/v1/users/getting-started/advanced`, {
		method: 'PATCH',
		body: { advanced },
	});
};

export const hideGettingStartedStep = (
	stepKey: GettingStartedStepKey,
): Promise<GettingStartedPanelData> => {
	return fetch<GettingStartedPanelData>(`/v1/users/getting-started/${stepKey}/hide`, {
		method: 'PATCH',
	});
};

export const updateGettingStartedCollapsedState = (
	collapsed: boolean,
): Promise<GettingStartedPanelData> => {
	return fetch<GettingStartedPanelData>('/v1/users/getting-started/collapse', {
		method: 'PATCH',
		body: { collapsed },
	});
};

export const updateGettingStartedShowCompletedAndHiddenStepsState = (
	showCompletedAndHiddenSteps: boolean,
): Promise<GettingStartedPanelData> => {
	return fetch<GettingStartedPanelData>('/v1/users/getting-started/showCompletedAndHiddenSteps', {
		method: 'PATCH',
		body: { showCompletedAndHiddenSteps },
	});
};
